import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.number.constructor";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import placeholderImg from "../pages/page-components/placeholderImg";
export default {
  data: function data() {
    return {};
  },
  components: {
    placeholderImg: placeholderImg
  },
  props: {
    theme: {
      type: Object | Array
    },
    setData: {
      type: Object | Array
    },
    cId: {
      type: Number
    },
    noEditor: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapState({
    componentsList: function componentsList(state) {
      return state.divpageShop.componentsList;
    }
  })),
  created: function created() {},
  mounted: function mounted() {},
  methods: _objectSpread({}, mapMutations(['updateData'])),
  watch: {
    setData: function setData(newVal, oldVal) {},
    componentsList: function componentsList(newVal, oldVal) {
      //添加的时候出发（解决没有移动的时候不emit数据）
      var that = this;
      that.updateData({
        componentsList: that.componentsList
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    // this.$root.Bus.$off('addHotSpot')
  }
};